// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"5cebfd8719fd7a6b10d0","883":"473a8cbfad313da2d74f"}[chunkId] + ".js";
};